var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81489 7.75721C6.55454 7.49686 6.55454 7.07475 6.81489 6.8144C7.07524 6.55405 7.49735 6.55405 7.7577 6.8144L14.3574 13.4141C14.6177 13.6744 14.6177 14.0965 14.3574 14.3569C14.097 14.6172 13.6749 14.6172 13.4146 14.3569L6.81489 7.75721Z",
    fill: "#1F2D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7577 17.1853C7.49735 17.4457 7.07524 17.4457 6.81489 17.1853C6.55454 16.925 6.55454 16.5028 6.81489 16.2425L16.243 6.8144C16.5033 6.55405 16.9254 6.55405 17.1858 6.8144C17.4461 7.07475 17.4461 7.49686 17.1858 7.75721L7.7577 17.1853Z",
    fill: "#1F2D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3002 16.2425C15.0398 15.9821 15.0398 15.56 15.3002 15.2997C15.5605 15.0393 15.9826 15.0393 16.243 15.2997L17.1858 16.2425C17.4461 16.5028 17.4461 16.925 17.1858 17.1853C16.9254 17.4457 16.5033 17.4457 16.243 17.1853L15.3002 16.2425Z",
    fill: "#1F2D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.393f5a26da5189493d33232cef72c985.svg";
export { ForwardRef as ReactComponent };